import React, { createContext, useState, useContext } from "react";

// Contexto de Produtos
const ProdutosContext = createContext();

export const ProdutosProvider = ({ children }) => {
  const [produtoEdit, setProdutoEdit] = useState(null);
  const [categorias, setCategorias] = useState([]);
  // O cardápio do cliente agora é carregado direto pelo Categorias (rolagem única); aqui
  // ficam só as operações do admin (categorias, cadastro, edição, imagens e inativação).

  // Listar categorias do restaurante
  const listarCategorias = async (restauranteId, isCadastro = false) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/public/categorias?restauranteId=${restauranteId}&isCadastro=${isCadastro}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authentication: access_token,
          },
        }
      );
      if (response) {
        const data = await response.json();
        setCategorias(data.content.map((categoria) => categoria));
        return data;
      } else {
        console.error("Erro ao listar categorias:", response);
      }
    } catch (error) {
      console.error("Erro ao listar categorias:", error);
    }
  };

  // Criar nova categoria
  const criarCategoria = async (restauranteId, novaCategoria) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/categorias?restauranteId=${restauranteId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authentication: access_token,
          },
          body: JSON.stringify(novaCategoria),
        }
      );
      if (response) {
        await listarCategorias(restauranteId); // Atualiza a lista de categorias
      } else {
        console.error("Erro ao criar categoria:", response);
      }
    } catch (error) {
      console.error("Erro ao criar categoria:", error);
    }
  };

  // Criar novo produto
  const criarProduto = async (restauranteId, novoProduto) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/restaurantes/${restauranteId}/cardapio`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authentication: access_token,
          },
          body: JSON.stringify(novoProduto),
        }
      );
      if (response) {
        const data = await response.json();
        return data.id;
      } else {
        console.error("Erro ao criar produto:", response);
      }
    } catch (error) {
      console.error("Erro ao criar produto:", error);
    }
  };

  // Adicionar imagem ao produto
  const adicionarImagemProduto = async (restauranteId, produtoId, imagem) => {
    try {
      const formData = new FormData();
      formData.append("file", imagem);
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/restaurantes/${restauranteId}/item/${produtoId}/imagem`,
        {
          method: "POST",
          headers: { Authentication: access_token },
          body: formData,
        }
      );
      if (response) {
      } else {
        console.error("Erro ao adicionar imagem:", response);
      }
    } catch (error) {
      console.error("Erro ao adicionar imagem:", error);
    }
  };

  

  const adicionarImagemS3 = async (restauranteId, produtoId, imagem) => {
    try {
      const formData = new FormData();
      formData.append("file", imagem);
      const user = sessionStorage.getItem("user");
      const {access_token} = JSON.parse(user);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/imagens?restaurantId=${restauranteId}&itemId=${produtoId}`,
        {
          method: "POST",
          headers: { 'Authentication': access_token },
          body: formData,
        }
      );
      if (response) {
        const data = await response.text(); // Captura a string retornada pelo servidor
        console.log("data", data);
        return data;
      }
    } catch (error) {
      console.error("Erro ao adicionar imagem:", error);
    }
  };

  // Adicionar Produto à Categoria
  const adicionarProdutoCategoria = async (categoriaId, produtoId) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/categorias/${categoriaId}/addItem/${produtoId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authentication: access_token,
          },
        }
      );

      if (response) {
        console.log("Produto adicionado à categoria com sucesso!");
      } else {
        console.error(
          "Erro ao adicionar produto à categoria:",
          response.statusText
        );
      }
    } catch (error) {
      console.error("Erro ao adicionar produto à categoria:", error);
    }
  };

  const editarProduto = async (restauranteId, produto) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/restaurantes/${restauranteId}/cardapio/${produto.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authentication: access_token,
          },
          body: JSON.stringify(produto),
        }
      );

      if (response.ok) {
        const data = await response.json();
        return data;
      } else {
        throw new Error(`Erro ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      throw error;
    }
  };

  const deletarImagemProduto = async (restaurantId, idItem) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/restaurantes/${restaurantId}/item/${idItem}/imagem`,
        {
          method: "DELETE",
          headers: {
            Authentication: access_token,
          },
        }
      );

      if (response.ok) {
        console.log("Imagem deletada com sucesso!");
        return true;
      } else {
        console.error("Erro ao deletar a imagem:", response.statusText);
        throw new Error(`Erro ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Erro ao deletar a imagem:", error);
      throw error;
    }
  };

  const inativarProduto = async (idItem, idRestaurante) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/restaurantes/${idRestaurante}/cardapio/${idItem}`,
        {
          method: "DELETE",
          headers: {
            Authentication: access_token,
          },
        }
      );

      if (response.ok) {
        console.log("Produto deletado com Sucesso!");
        return true;
      } else {
        console.error("Erro ao deletar a Produto:", response.statusText);
        throw new Error(`Erro ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Erro ao deletar a Produto:", error);
      throw error;
    }
  };

  return (
    <ProdutosContext.Provider
      value={{
        categorias,
        produtoEdit,
        adicionarImagemProduto,
        criarProduto,
        criarCategoria,
        listarCategorias,
        adicionarProdutoCategoria,
        setProdutoEdit,
        editarProduto,
        deletarImagemProduto,
        inativarProduto,
      }}
    >
      {children}
    </ProdutosContext.Provider>
  );
};

export const useProdutos = () => useContext(ProdutosContext);
